export const facilitiesCorpHQImport = [
    { src: require('../../images/Facilities/Corporate Headquarters/1.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/2.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/3.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/4.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/5.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/6.jpg'), width: 3, height: 2 },
    { src: require('../../images/Facilities/Corporate Headquarters/7.jpg'), width: 3, height: 2 }
]